import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFProductWinAdd } from '@/components/UI/svg/mm100';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');

export default function Comp({ callBack }: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();
    const imgLocale = getImageLocal(locale, ['cn']);
    const openAllWin = () => callBack('listD2-modal');

    return (
        <div className={`${css.listD} listD2`} style={{ paddingTop: '1.2rem', marginBottom: '0.4rem' }}>
            <div className="kit-inter">
                <div className="kit-ms1">{t('presale.product.listD2_ms1')}</div>
                <div className="kit-ms2">{t('presale.product.listD2_ms2')}</div>
                <div className="kit-ms3">{t('presale.product.listD2_ms3')}</div>
                <div className="more-win-fun more-win-fun2" onClick={openAllWin}>
                    {t('presale.product.h5_learn_more')}
                    <span className="more-win-fun-icon">
                        <EFProductWinAdd />
                    </span>
                </div>
                {!['de', 'fr', 'it', 'es'].includes(locale) && (
                    <div className="kit-img kit-img2">
                        <EFPic name={[`listD2_${imgLocale}.webp`, `listD2_${imgLocale}.jpg`]} className="fullImgs" alt={t('presale.product.listD2_btn1')} />
                    </div>
                )}
                {['de', 'fr', 'it', 'es'].includes(locale) && (
                    <div className="kit-img kit-img2">
                        <EFPic name={[`listD2_${locale}.webp`, `listD2_${locale}.jpg`]} className="fullImgs" alt={t('presale.product.listD2_btn1')} />
                    </div>
                )}
            </div>
        </div>
    );
}
